export default __webpack_public_path__ + "static/media/patient-default.90526b32.svg";